define.alias("shared/utils/string-formatters/snake-to-camel", "media/utils/string-formatters/snake-to-camel");